const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchAccountStatement(params) {
  const query = new URLSearchParams({
    companyId: String(params.companyId),
    periodId: String(params.periodId),
    page: String(params.page || 1),
    size: String(params.size || 100)
  });
  if (params.startDate) {
    query.set('startDate', params.startDate);
  }
  if (params.endDate) {
    query.set('endDate', params.endDate);
  }
  if (params.accountCode) {
    query.set('accountCode', params.accountCode);
  }
  if (params.accountGroup) {
    query.set('accountGroup', params.accountGroup);
  }

  const response = await fetch(`${API_BASE}/api/reports/account-statement?${query.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Hesap ekstresi verisi alinamadi.');
}

export async function fetchAccountOptions(companyId, periodId, search) {
  const query = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  if (search) {
    query.set('search', search);
  }
  const response = await fetch(`${API_BASE}/api/reports/account-statement/accounts?${query.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Hesap listesi alinamadi.');
}

export async function fetchAccountGroupOptions(companyId, periodId) {
  const query = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  const response = await fetch(`${API_BASE}/api/reports/account-statement/account-groups?${query.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Hesap grubu listesi alinamadi.');
}

const reportAccountStatementService = {
  fetchAccountStatement,
  fetchAccountOptions,
  fetchAccountGroupOptions
};

export default reportAccountStatementService;
